import { render } from "./BannerMessage.vue?vue&type=template&id=04a1a6c8&scoped=true"
import script from "./BannerMessage.vue?vue&type=script&lang=js"
export * from "./BannerMessage.vue?vue&type=script&lang=js"

import "./BannerMessage.vue?vue&type=style&index=0&id=04a1a6c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a1a6c8"]])

export default __exports__